class OError extends Error {
    constructor(message, info, cause) {
        super(message);
        this.name = this.constructor.name;
        if (info) this.info = info;
        if (cause) this.cause = cause;
    }

    withInfo(info) {
        this.info = info;
        return this;
    }

    withCause(cause) {
        this.cause = cause;
        return this;
    }

    static tag(error, message, info) {
        const oError = error;

        if (!oError._oErrorTags) oError._oErrorTags = [];

        let tag;
        if (Error.captureStackTrace) {
            tag = { name: "TaggedError", message, info };
            Error.captureStackTrace(tag, OError.tag);
        } else {
            tag = new TaggedError(message || "", info);
        }

        if (oError._oErrorTags.length >= OError.maxTags) {
            if (oError._oErrorTags[1] === DROPPED_TAGS_ERROR) {
                oError._oErrorTags.splice(2, 1);
            } else {
                oError._oErrorTags[1] = DROPPED_TAGS_ERROR;
            }
        }
        oError._oErrorTags.push(tag);

        return error;
    }

    static getFullInfo(error) {
        const info = {};

        if (!error) return info;

        const oError = error;

        if (oError.cause) Object.assign(info, OError.getFullInfo(oError.cause));
        if (typeof oError.info === "object") Object.assign(info, oError.info);

        if (oError._oErrorTags) {
            for (const tag of oError._oErrorTags) {
                Object.assign(info, tag.info);
            }
        }

        return info;
    }

    static getFullStack(error) {
        if (!error) return "";

        const oError = error;
        let stack = oError.stack || oError.message || "(no stack)";

        if (Array.isArray(oError._oErrorTags) && oError._oErrorTags.length) {
            stack += `\n${oError._oErrorTags.map((tag) => tag.stack).join("\n")}`;
        }

        const causeStack = OError.getFullStack(oError.cause);
        if (causeStack) {
            stack += "\ncaused by:\n" + indent(causeStack);
        }

        return stack;
    }
}

OError.maxTags = 100;

class TaggedError extends OError {}

const DROPPED_TAGS_ERROR = {
    name: "TaggedError",
    message: "... dropped tags",
    stack: "TaggedError: ... dropped tags",
};

function indent(string) {
    return string.replace(/^/gm, "    ");
}

module.exports = OError;
module.exports.default = OError;
